import { Component, OnInit } from '@angular/core';
import { ISubscription } from 'rxjs/Subscription';
import { Router } from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import { NgForm } from '@angular/forms';
import { CommonService } from '../services/common.service';
import { UserObject } from '../../models/userdetails';
declare var $: any;
declare let fbq:Function;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class HeaderComponent implements OnInit {

  isLoggedIn = false;
  showForgotPw:boolean=false;
  activeTab = 'booking';
  flagName = 'netherland_flag.png';
  country = 'Netherland';
  userName = '';
  isNewRegn = false;
  isClearLoginDetails = false;
  showSubmenu = false;
  toggle=false;
  $userNameSubscription: ISubscription;
  counter:string='245333';
  htmlContent:string='';

  emailAddress:any='';
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";  
  isSuccess:boolean=false;
  isValidFormSubmitted = false;  
  nameSub: string;
  nameSubCheck: boolean =false;
  constructor(public _commonService: CommonService, public translate: TranslateService, private _router: Router) {
    //this.getUrl();
  }

  ngOnInit() {
    this._commonService.loadScript();
    this.checkLogin();
    this.getVistorCount();    
    this.generateVisitorCount()
  
  }
  getUrl(){
    var url = this._router.url;

    if(url === '/vliegtickets/passenger-info' 
    || url === '/vliegtickets/betaling'
    || url === '/vliegtickets/pricing' 
    || url === '/vliegtickets/parking' 
    || url === '/vliegtickets/payment/error' 
    || url === '/vliegtickets/payment/success' 
    || url === '/vliegtickets/bedanktpagina'){
      $('#headerLoginModalForSteps').modal('show'); 
    }else{
      $('#headerLoginModal').modal('show');
    }

   
  }

  generateVisitorCount(){
    var count = this.counter.length;
    this.htmlContent = '';
    for(var i=0;i<count;i++){
      this.htmlContent+= "<span style='display: inline-block;padding: 6px 6px 4px;border-radius: 3px;background: #b09dc4;margin-right: -2px;'>"+this.counter.charAt(i)+"</span>"
    }
  }

  showForgotPassword($event){
    this.isNewRegn = false;
    this.showForgotPw = true;
  }

  checkLogin() {
      const ISLOGGED = localStorage.getItem('isLogged') === 'true' ? true : false;
      this._commonService.isLoggedIn.next(ISLOGGED);
      this._commonService.isLoggedIn.subscribe((data: any) => {

        this.isLoggedIn = data ? data : false;

        this._commonService.userDetails.subscribe((user:UserObject) =>{
          if(user == undefined || user == null){
            this.loadFromStorage();
          }
          else{
            this.userName = user.name;
          }

        } );

      });
  }

  loadFromStorage(){
    if (localStorage.getItem('userDetails')) {
      this._commonService.setUserDetails(JSON.parse(localStorage.getItem('userDetails')));
    }
  }

  getVistorCount(){
    this._commonService.getCounterValue().subscribe((response:number)=>{    
      this.counter = response.toString();
      this.generateVisitorCount()
    })
  }



  changeLang(code, flagname, region) {
    this.translate.use(code);
    this.flagName = flagname;
    this.country = region;
  }

  showMenu(toggle:boolean){
    this.toggle = !toggle;
  }

  tabSwitch(tabname) {
    this.showMenu(this.toggle);
    this.activeTab = tabname;
    if (tabname === 'home') {
      this._router.navigate(['']);
    }
    else if (tabname === 'faq') {
      this._router.navigate(['/veelgestelde-vragen']);
    } else if (tabname === 'contact'){
      this._router.navigate(['/contact']);
    } else if (tabname === 'credits'){
      this._router.navigate(['/ticks-spaarsysteem']);
    }else if (tabname === 'nieuwsbrief'){
      this.nameSubCheck = false; 
      $('#headerNewsLetter').modal('show');
    } 
    else if (tabname === 'vacatures'){
      this._router.navigate(['/vacatures']);
    } 
    else {
      this._router.navigate(['/over-ons']);
    }
  }

  redirectToContact() {
    const url = this._router.serializeUrl(
      this._router.createUrlTree(['/contact'])
    );
    window.open(url, '_blank');
  }

  resetLoginDetails() {
    this.isNewRegn = false;
    this.isClearLoginDetails = true;
  }

  logout() {  
    this._commonService.isLoggedIn.next(false);
     localStorage.removeItem('userDetails');
     this._commonService.userDetails.next(null);
     localStorage.removeItem('isLogged');
    // localStorage.removeItem('userName');
   // this._commonService.userName.next('');
    if (this._router.url === '/userAccount') {
      this._router.navigate(['/']);
    }
  }

  onFormSubmit(form: NgForm) {  
    $('#headerNewsLetter').modal('hide');
    this.isValidFormSubmitted = false;  
    debugger;
    setTimeout(() => {
      if (typeof fbq === 'function') {
        fbq('track', 'Purchase', {
          value: 500,
          content_ids: 'EUR',
        });
        console.log('Facebook Pixel Purchase event fired:', { value: 500, content_ids: 'EUR' });
      } else {
        console.error('Facebook Pixel is not loaded.');
      }
    }, 4000);
   // console.log(form)
    if (form.invalid) {  
       return;  
    }  
    if(this.nameSub == null || this.emailAddress == null)
    {
      this.nameSubCheck=true;
      return;
    }
     
    this._commonService.subscribeNewsLetter(this.emailAddress, this.nameSub).subscribe((response:any)=>{
     this.isSuccess = true;
      
     $(function() { fbq('track', 'CompleteRegistration'); });
     $('#headerNewsLetter').modal('show');
    })
    this.isValidFormSubmitted = true; 
    this.nameSubCheck = false; 
    form.resetForm();  

    setTimeout(function(){
      $('#headerNewsLetter').modal('hide');
    }, 7000);
    
 }  

}
